var React = require('react');

function PaginationChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.36 5.232a1 1 0 0 0-.128 1.408L13.698 12l-4.466 5.36a1 1 0 0 0 1.536 1.28l5-6a1 1 0 0 0 0-1.28l-5-6a1 1 0 0 0-1.408-.128Z","fill":"#1D191F"}));
}

PaginationChevronRight.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = PaginationChevronRight;

PaginationChevronRight.default = PaginationChevronRight;
